angular.module('picmonicng').directive('pathwaysTrack', [
  '$uiViewScroll',
  'UserService',
  '$state',
  '$modal',
  function ($uiViewScroll, UserService, $state, $modal) {
    return {
      restrict: 'E',
      templateUrl: '/templates/directives/pathways-track.html',
      link: function (scope, element) {
        if (scope.track.track_id == scope.track_id) {
          $uiViewScroll(element.find('.track-anchor'));
        }

        scope.show_quiz = UserService.quizSplitText();

        scope.startQuiz = function () {
          if (UserService.user.user_id) {
            $state.go('app.quiz', {
              quiz_type: 'track',
              resource_id: scope.track.track_id,
            });
          } else {
            $modal.open({
              templateUrl: '/templates/modals/register-modal.html',
              windowClass: 'registration-cta-modal full-screen-modal',
              backdropClass: 'below-nav modal-body-reduced',
              size: 'sm',
              scope: scope,
              backdrop: 'static',
              controller: 'RegisterModalController',
              resolve: {
                card: function () {
                  return {
                    name: scope.track.name,
                  };
                },
                market_id: function () {
                  return null;
                },
                copy: function () {
                  return null;
                },
                redirect: function () {
                  return '/quiz/track/' + scope.track.track_id;
                },
                extraParams: function () {
                  return null;
                },
              },
            });
          }
        };
      },
    };
  },
]);
